import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import CreatePollForm from "../CreatePoll/CreatePollForm";
import classes from "./EditPollModal.module.scss";

const EditPollModal = ({
  formMode,
  pollId,
  handleSearchQuery,
  isEditModal,
  setisEditModal,
}) => {
  const socialState = useSelector((state) => state.socialReducer);
  const { editPollResponseData } = socialState;

  useEffect(() => {
    if (editPollResponseData) {
      setisEditModal(false);
      handleSearchQuery();
    }
  }, [editPollResponseData, setisEditModal, handleSearchQuery]);

  return (
    <Modal
      heading={"Edit Poll"}
      isOpen={isEditModal}
      toggle={() => setisEditModal(false)}
      width={"110"}
    >
      <div className={classes.editPoll}>
        <CreatePollForm
          formMode={formMode}
          pollId={pollId}
          setisEditModal={setisEditModal}
        />
      </div>
    </Modal>
  );
};

export default EditPollModal;
